import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SubscriptionSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <Box sx={{ backgroundColor: '#F2F2F2', minHeight: '100vh', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="sm">
        <Card sx={{ borderRadius: 4, p: { xs: 3, md: 4 } }}>
          <CardContent>
            <Stack spacing={3} alignItems="center">
              <CheckCircleIcon color="success" sx={{ fontSize: 64 }} />
              <Typography variant="h4" fontWeight={800} align="center">
                Děkujeme za aktivaci předplatného!
              </Typography>
              <Typography variant="body1" color="text.secondary" align="center">
                Platbu jsme přijali a právě připravujeme vaše kredity. Potvrzení o platbě a fakturu
                najdete ve své e‑mailové schránce. V zákaznickém portálu můžete kdykoli spravovat své
                předplatné.
              </Typography>
              {sessionId && (
                <Typography variant="caption" color="text.secondary">
                  ID transakce: {sessionId}
                </Typography>
              )}
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => navigate('/dashboard')}
                >
                  Pokračovat do aplikace
                </Button>
                <Button variant="outlined" onClick={() => navigate('/pricing')}>
                  Zpět na tarify
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default SubscriptionSuccessPage;
